import axiosInstance from "./api_helper";

const userService = {

    /* ============================================
       LIST USERS (pagination + filters)
    ============================================ */
    list: async (params = {}) => {
        return axiosInstance.get("/api/users", { params });
    },

    /* ============================================
       GET USER BY ID
    ============================================ */
    getById: async (id) => {
        return axiosInstance.get(`/api/users/${id}`);
    },

    /* ============================================
       CREATE USER
    ============================================ */
    add: async (data) => {
        return axiosInstance.post("/api/users", data, {
            headers: { "Content-Type": "application/json" }
        });
    },

    /* ============================================
       UPDATE USER
    ============================================ */
    update: async (id, data) => {
        return axiosInstance.put(`/api/users/${id}`, data, {
            headers: { "Content-Type": "application/json" }
        });
    },

    /* ============================================
       DELETE USER
    ============================================ */
    delete: async (id) => {
        return axiosInstance.delete(`/api/users/${id}`);
    },

    /* ============================================
       ACTIVATE / DEACTIVATE USER
    ============================================ */
    activate: async (id) => {
        return axiosInstance.put(`/api/users/${id}/activate`);
    },

    deactivate: async (id) => {
        return axiosInstance.put(`/api/users/${id}/deactivate`);
    },

    /* ============================================
       RESET PASSWORD
    ============================================ */
    resetPassword: async (id, newPassword) => {
        return axiosInstance.put(
            `/api/users/${id}/reset-password`,
            null,
            { params: { newPassword } }
        );
    },

    /* ============================================
       SEARCH USERS
    ============================================ */
    search: async (filters = {}, params = {}) => {
        return axiosInstance.post("/api/users/search", filters, {
            params
        });
    },

    /* ============================================
       COUNT USERS
    ============================================ */
    count: async () => {
        return axiosInstance.get("/api/users/count");
    },

};

export default userService;
